import type { Channel, Coverage, Quote } from "@/api_client";

import { getEcommerceRemove } from "./data/ecommerce";
import type { RemoveFromCart } from "./types/types";

export const createRemoveFromCart = (
  product: Quote,
  channel: Channel,
  coverageContent: Record<string, Coverage> | undefined,
): RemoveFromCart | undefined => {
  if (!product) {
    return;
  }
  const event: RemoveFromCart = {
    event: "Remove from Cart",
    ecommerce: getEcommerceRemove(product, channel, coverageContent),
  };
  return event;
};
